export default "__VITE_ASSET__f095da4d__"